import React from "react";
import { Row, Col, Form, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaSearch, FaEye } from "react-icons/fa";

const EditUserForm = ({
    user, setUser,
    trader,
    namaUPT,
    services, setServices,
    onClickUPT,
    onViewDoc,
    onReplaceDoc,
    isReplacingDoc,
}) => {
    return (
        <>
            {/* Nama User */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0">
                    Nama User*
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        type="text"
                        required
                        placeholder="Nama User"
                        value={user.NAMA || ""}
                        onChange={(e) => setUser({ ...user, NAMA: e.target.value })}
                    />
                </Col>
            </Form.Group>

            {/* Jabatan */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0">
                    Jabatan*
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        type="text"
                        placeholder="Jabatan"
                        value={user.JABATAN || ""}
                        onChange={(e) => setUser({ ...user, JABATAN: e.target.value })}
                        required
                    />
                </Col>
            </Form.Group>

            {/* No Identitas */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0">
                    No. Identitas KTP/KITAS*
                </Form.Label>
                <Col sm="9">
                    <Row>
                        <Col sm="3">
                            <select
                                className="form-select mb-3 shadow-none"
                                value={user.JNS_ID || ""}
                                onChange={(e) => setUser({ ...user, JNS_ID: e.target.value })}
                            >
                                <option value="">Pilih Identitas</option>
                                <option value="1">KTP</option>
                                <option value="2">SIM</option>
                                <option value="3">Kartu Keluarga</option>
                            </select>
                        </Col>
                        <Col sm="7">
                            <Form.Control
                                type="text"
                                placeholder="Nomor Identitas"
                                value={user.NO_ID || ""}
                                onChange={(e) => setUser({ ...user, NO_ID: e.target.value })}
                                required
                            />
                        </Col>
                        <Col sm="1" className="align-self-center">
                            <OverlayTrigger placement="bottom" overlay={<Tooltip>Lihat Identitas</Tooltip>}>
                                <Button size="sm" variant="info" onClick={() => onViewDoc(trader.FILE_ID, 2)}>
                                    <FaEye />
                                </Button>
                            </OverlayTrigger>
                        </Col>
                    </Row>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0">
                    Ganti File KTP/Identitas
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        type="file"
                        accept=".pdf,.png,.jpg,.jpeg"
                        disabled={isReplacingDoc}
                        onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) onReplaceDoc(2, file);
                            e.target.value = "";
                        }}
                    />
                    <Form.Text muted>Unggah file baru di sini kalau pemohon mengirim dokumen identitas perbaikan. Maks. 1MB.</Form.Text>
                </Col>
            </Form.Group>

            {/* Alamat Rumah */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 text-dark">
                    Alamat Rumah
                </Form.Label>
            </Form.Group>
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-top mb-0 ps-5">
                    Jalan / No / Rt / Rw
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        as="textarea"
                        rows="4"
                        placeholder="Alamat Rumah"
                        value={user.ALAMAT || ""}
                        onChange={(e) => setUser({ ...user, ALAMAT: e.target.value })}
                        required
                    />
                </Col>
            </Form.Group>

            {/* Email */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 text-dark ps-5">
                    Pos Elektronik/Email*
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        type="email"
                        placeholder="Email Pengguna"
                        value={user.EMAIL || ""}
                        onChange={(e) => setUser({ ...user, EMAIL: e.target.value })}
                        required
                    />
                </Col>
            </Form.Group>

            {/* No HP */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 ps-5">
                    Nomor Handphone*
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        type="text"
                        placeholder="Nomor Handphone"
                        value={user.TELEPON || ""}
                        onChange={(e) => setUser({ ...user, TELEPON: e.target.value })}
                        required
                    />
                </Col>
            </Form.Group>

            {/* UPT */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 text-dark">
                    Unit Pelaksana Teknis
                </Form.Label>
            </Form.Group>
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 text-dark ps-5">
                    UPT*
                </Form.Label>
                <Col sm="9">
                    <Row>
                        <Col sm="8">
                            <Form.Control type="text" placeholder="UPT" value={namaUPT || ""} disabled />
                        </Col>
                        <Col sm="1" className="align-self-center">
                            <Button size="sm" variant="primary" onClick={onClickUPT}>
                                <FaSearch />
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Form.Group>

            {/* Username */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 text-dark">
                    Data Userlogin
                </Form.Label>
            </Form.Group>
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 text-dark ps-5">
                    User Name*
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        type="text"
                        placeholder="User Name"
                        value={user.USERNAME || ""}
                        onChange={(e) => setUser({ ...user, USERNAME: e.target.value })}
                        required
                    />
                </Col>
            </Form.Group>

            {/* Jenis Layanan */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 text-dark ps-5">
                    Jenis Layanan*
                </Form.Label>
                <Col sm="9">
                    <Row>
                        <Col>
                            <Form.Check
                                type="checkbox"
                                id="checkSMKHP"
                                label="Sertifikasi SMKHP"
                                checked={services.first}
                                onChange={() => setServices((s) => ({ ...s, first: !s.first }))}
                            />
                        </Col>
                        <Col>
                            <Form.Check
                                type="checkbox"
                                id="checkPBUMKU"
                                label="PB-UMKU"
                                checked={services.second}
                                onChange={() => setServices((s) => ({ ...s, second: !s.second }))}
                            />
                        </Col>
                    </Row>
                </Col>
            </Form.Group>
        </>
    );
};

export default EditUserForm;